export default "__VITE_ASSET__CF4z8Xu$__"